import ShipmentBridges from 'components/modules/shipments/ShipmentBridges';
import CargomaticModal from 'components/v2/modal';
import { t } from 'i18next';
import React, { forwardRef } from 'react';

export const ShipmentLegEditor = forwardRef(({ stopEditing, node }, ref) => {
  const { shipment_oid, shipment_id } = node?.data || {};
  const handleHide = () => {
    stopEditing();
  };

  const getFooter = () => {
    return (
      <div className="flex items-center justify-end">
        <button
          className="button button-secondary"
          type="button"
          onClick={handleHide}
        >
          {t('CLOSE')}
        </button>
      </div>
    );
  };
  return (
    <CargomaticModal
      title={`${t('SHIPMENT_BRIDGE_AND_EVENT_CODES')} - ${shipment_id}`}
      titleClassNames="font-semibold leading-none tracking-tight"
      dialogClassName="w-[80vw] h-[80vh]"
      contentClassName="h-full"
      showCloseButton={false}
      show={true}
      onHide={handleHide}
      body={
        <ShipmentBridges
          shipmentId={shipment_oid}
          showHeader={false}
          isPaginated={false}
        />
      }
      footer={getFooter()}
    />
  );
});
